const WpTabs = (() => {
    const tabSelector = '[data-bs-toggle="tab"]';
    const pendingRequestByTab = new WeakMap();

    function prefersReducedMotion() {
        return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    }

    function isRemoteTab(tabTrigger) {
        const $tabTrigger = jQuery(tabTrigger);
        const href = $tabTrigger.attr('href');

        return Boolean(href && href !== '#' && $tabTrigger.data('bs-target'));
    }

    function updatePaneWithTransition(target, html) {
        const pane = document.querySelector(target);
        if (!pane) return;

        const updateDom = () => {
            jQuery(target).empty().html(html);
        };

        if (prefersReducedMotion()) {
            updateDom();
            return;
        }

        if (typeof document.startViewTransition === 'function') {
            pane.classList.add('tab-pane-vt');
            const transition = document.startViewTransition(() => {
                updateDom();
            });

            transition.finished.finally(() => {
                pane.classList.remove('tab-pane-vt');
            });
            return;
        }

        updateDom();
    }

    function showAlert(type, message) {
        if (typeof message !== 'string' || !message.length) {
            return;
        }

        const $alert = jQuery('#alert');
        if ($alert.length === 0) {
            return;
        }

        const iconClass = type === 'success'
            ? 'fa-circle-check'
            : 'fa-circle-exclamation';

        $alert.prepend(
            '<div class="alert alert-' + type + ' alert-dismissible">' +
                '<i class="fa-solid ' + iconClass + '"></i> ' + message +
                ' <button type="button" class="btn-close" data-bs-dismiss="alert"></button>' +
            '</div>'
        );
    }

    function handleTabResponse(tabTrigger, response) {
        const $tabTrigger = jQuery(tabTrigger);
        const target = $tabTrigger.data('bs-target');

        if (!target) {
            return;
        }

        if (typeof response === 'string') {
            updatePaneWithTransition(target, response);
            return;
        }

        if (!response || typeof response !== 'object' || !('success' in response)) {
            return;
        }

        if (response.success) {
            if (typeof response?.data?.html === 'string') {
                updatePaneWithTransition(target, response.data.html);
            }

            return;
        }

        if (typeof response?.data?.message === 'string') {
            showAlert('danger', response.data.message);
        }
    }

    function loadTabContent(tabTrigger) {
        if (!isRemoteTab(tabTrigger)) {
            return null;
        }

        const existingRequest = pendingRequestByTab.get(tabTrigger);
        if (existingRequest) {
            return existingRequest;
        }

        const $tabTrigger = jQuery(tabTrigger);
        const href = $tabTrigger.attr('href');

        const request = jQuery.ajax({
            url: href,
            type: 'GET',
            context: tabTrigger,
            beforeSend: function () {
                jQuery(this).data('loading', true);
                toggleButtonLoading(this, true);
            },
            success: function (response) {
                handleTabResponse(this, response);
            },
            error: function (xhr, status, error) {
                if (status === 'abort') {
                    return;
                }

                console.error('Chyba nacitani tabu:', xhr);
                showAlert('danger', 'Chyba spojeni se serverem: ' + error);
            },
            complete: function () {
                jQuery(this).removeData('loading');
                toggleButtonLoading(this, false);
                pendingRequestByTab.delete(this);
            }
        });

        pendingRequestByTab.set(tabTrigger, request);
        return request;
    }

    function updateHash(tabTrigger) {
        const tabId = tabTrigger.id;
        if (!tabId) {
            return;
        }

        const { origin, pathname, search } = window.location;
        history.replaceState(null, '', origin + pathname + search + '#' + tabId);
    }

    function activateTabById(tabId) {
        const tabTrigger = document.getElementById(tabId);
        if (!tabTrigger) return;

        const tab = bootstrap.Tab.getOrCreateInstance(tabTrigger);
        tab.show();

        if (tabTrigger.classList.contains('active')) {
            updateHash(tabTrigger);
            loadTabContent(tabTrigger);
        }
    }

    function handleTabShown(event) {
        const tabTrigger = event.target.closest(tabSelector);
        if (!tabTrigger) {
            return;
        }

        updateHash(tabTrigger);
        loadTabContent(tabTrigger);
    }

    function handleTabClick(event) {
        const tabTrigger = event.target.closest(tabSelector);
        if (!tabTrigger || !isRemoteTab(tabTrigger)) {
            return;
        }

        if (tabTrigger.classList.contains('active')) {
            event.preventDefault();
            loadTabContent(tabTrigger);
        }
    }

    function init() {
        document.addEventListener('shown.bs.tab', handleTabShown);
        document.addEventListener('click', handleTabClick);

        window.addEventListener('load', () => {
            const hash = window.location.hash;
            if (!hash) return;

            activateTabById(hash.substring(1));
        });
    }

    function sync() {
        return undefined;
    }

    return { init, sync, refresh: sync, activateTabById, loadTabContent };
})();

window.WpTabs = WpTabs;
window.activateTabById = WpTabs.activateTabById;
WpTabs.init();
